import { Stack, Typography } from '@mui/material';
import config from '~/config';
import { colors } from '~/theme';

const LEGAL_DISCLAIMER =
  'A CUB não realiza qualquer atividade privativa de instituições financeiras, como financiamentos e/ou ' +
  'empréstimos direto a seus clientes. Nos termos da Resolução nº 4.935, de 29 de junho de 2021, do Conselho ' +
  'Monetário Nacional, a CUB atua meramente como Correspondente Bancário das instituições financeiras: (i) BMP ' +
  'Sociedade de Crédito Direto S.A. (CNPJ: 34.337.707/0001-00) e (ii) QI Sociedade de Crédito Direto S.A. (CNPJ ' +
  'nº 32.402.502/0001-35).';

interface FooterProps {
  showLegalDisclaimer?: boolean;
}

export const Footer = ({ showLegalDisclaimer = false }: FooterProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <Stack spacing={0.5}>
      <Typography variant="caption" sx={{ color: colors.neutralBluish500 }}>
        {currentYear} CUB. All Rights Reserved - {config.CUB_MAIN_DOCUMENT}
      </Typography>
      <Typography variant="caption" sx={{ color: colors.neutralBluish500 }}>
        Para mais informações sobre segurança, acesse o{' '}
        <a
          href={config.CUB_PRIVACY_POLICY_URL}
          target="_blank"
          rel="noreferrer"
          style={{ color: colors.neutralBluish500, textDecoration: 'underline' }}
        >
          Termo de privacidade
        </a>{' '}
        da plataforma CUB.
      </Typography>
      {showLegalDisclaimer && (
        <Typography variant="caption" sx={{ color: colors.neutralBluish500 }}>
          {LEGAL_DISCLAIMER}
        </Typography>
      )}
    </Stack>
  );
};
